export enum KeyboardKey {
    Esc = "Esc",
    Escape = "Escape",
    Enter = "Enter",
}
